module.exports = __webpack_public_path__ + "img/img7.f8f0a473.png";